const initProductGallery = () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-product-main-image]');
    const thumbs = gallery.querySelectorAll('[data-product-thumb]');
    if (!mainImage || !thumbs.length) return;
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.imageSrc;
        const alt = thumb.dataset.imageAlt || '';
        if (src) {
          mainImage.src = src;
          mainImage.alt = alt;
        }
        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });
};

const initCollectionFilters = () => {
  document.querySelectorAll('[data-collection-root]').forEach((root) => {
    const typeSelect = root.querySelector('[data-filter-type]');
    const tagSelect = root.querySelector('[data-filter-tag]');
    const items = root.querySelectorAll('[data-product-item]');
    if (!items.length) return;
    const applyFilters = () => {
      const activeType = typeSelect?.value || '';
      const activeTag = tagSelect?.value || '';
      items.forEach((item) => {
        const matchesType = !activeType || item.dataset.productType === activeType;
        const matchesTag = !activeTag || (item.dataset.productTags || '').split(' ').includes(activeTag);
        item.classList.toggle('is-hidden', !(matchesType && matchesTag));
      });
    };
    typeSelect?.addEventListener('change', applyFilters);
    tagSelect?.addEventListener('change', applyFilters);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initProductGallery();
  initCollectionFilters();
});
